import { z } from 'zod'
import type { Hex } from '../../types'
import type { HeadersInput } from '../types'
import type { Contract } from '../types'
import type { RoutescanClient } from './client'

type GetContractSourceCodeForVerifiedContractParameters = {
  client: RoutescanClient
  address: Hex
  headers?: HeadersInput
}

const resultSchema = z.array(
  z.object({
    ABI: z.string().optional(),
    ContractName: z.string().optional(),
  }),
)

/** {@link https://docs.etherscan.io/routescan/api-endpoints/contracts#get-contract-source-code-for-verified-contract-source-codes} */
export const getContractSourceCodeForVerifiedContract = async ({
  client,
  address,
  headers,
}: GetContractSourceCodeForVerifiedContractParameters): Promise<
  Contract | undefined
> => {
  const result = await client.get({
    path: '',
    query: {
      module: 'contract',
      action: 'getsourcecode',
      address,
    },
    resultSchema,
    headers,
  })
  if (result.length === 0) {
    return undefined
  }
  const contract = result[0]
  if (
    contract.ABI === undefined ||
    contract.ABI.length === 0 ||
    contract.ContractName === undefined ||
    contract.ContractName.length === 0
  ) {
    return undefined
  }

  return {
    abi: contract.ABI,
    name: contract.ContractName,
  }
}
